import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SidebarProject from '@templates/dashboard/SidebarProject';
import { Switch, Route, Redirect, useRouteMatch, useLocation } from 'react-router-dom';
import PagePersonalProfile from '@templates/profile/Personal';
import axios from 'axios';
import api from 'API';
import Home from '@templates/dashboard/Home';
import Magma from '@templates/dashboard/Magma';
import Finarium from '@templates/dashboard/Finarium';
import Unify from '@templates/dashboard/Unify';
import Spinner from '@atoms/spinner';
import { PrivateRoute } from '../../PrivateRoute';
import Monesto from '@templates/dashboard/Monesto';

const Wrapper = ({ userType }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { path, url } = useRouteMatch();

  const [spaces, setSpaces] = useState(null);
  const [magmaToken, setMagmaToken] = useState(null);
  const [finariumToken, setFinariumToken] = useState(null);
  const [unifyToken, setUnifyToken] = useState(null);
  const [monestoToken, setMonestoToken] = useState(null);
  const [magmaUrl, setMagmaUrl] = useState(null);
  const [finariumUrl, setFinariumUrl] = useState(null);
  const [unifyUrl, setUnifyUrl] = useState(null);
  const [monestoUrl, setMonestoUrl] = useState(null);

  useEffect(() => {
    getSpaces();
  }, []);

  const getSpaces = async () => {
    try {
      const response = await axios(api.users.spaces().AXIOS('GET'));

      setSpaces(response.data.data);
      const magmaObj = response.data.data.find((space) => space.id === 1);
      if (magmaObj) {
        setMagmaToken(magmaObj.token?.access_token);
        setMagmaUrl(magmaObj.fe_url);
      }

      const finariumObj = response.data.data.find((space) => space.id === 3);
      if (finariumObj) {
        setFinariumToken(finariumObj.token?.access_token);
        setFinariumUrl(finariumObj.fe_url);
      }

      const unifyObj = response.data.data.find((space) => space.id === 2);
      if (unifyObj) {
        setUnifyToken(unifyObj.token?.access_token);
        setUnifyUrl(unifyObj.fe_url);
      }

      const monestoObj = response.data.data.find((space) => space.id === 4);
      if (monestoObj) {
        setMonestoToken(monestoObj.token?.access_token);
        setMonestoUrl(monestoObj.fe_url);
      }
    } catch (err) {
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const handleOauthSuccess = () => {
    getSpaces();
  };

  if (isLoading) {
    return (
      <div className='dashboard-wrapper'>
        <Spinner />
      </div>
    );
  }

  // // Отладка
  // console.log('=== ДЕБАГ ИНФОРМАЦИЯ ===');
  // console.log('Текущий путь:', location.pathname);
  // console.log('path из useRouteMatch:', path);
  // console.log('finariumToken:', finariumToken);
  // console.log('isLoading:', isLoading);
  // console.log('========================');
  //
  // console.log('Текущий путь:', location.pathname); // /company/dashboard/home/crypto
  // console.log('path из useRouteMatch():', path); // Должно быть /company/dashboard
  // console.log('redirectTo path:', `${path}/home`); // /company/dashboard/home
  // console.log('Маршрут для crypto:', `${path}/crypto`); // /company/dashboard/crypto
  //
  // console.log('Текущий путь:', location.pathname);
  // console.log('finariumToken:', finariumToken);
  // console.log('magmaToken:', magmaToken);
  // console.log('unifyToken:', unifyToken);

  return (
    <div className='dashboard-wrapper'>
      <SidebarProject
        basePath={url} // url = /company/dashboard
        spaces={spaces}
        isMagmaTokenAvailable={!!magmaToken}
        isFinariumTokenAvailable={!!finariumToken}
        isUnifyTokenAvailable={!!unifyToken}
        isMonestoTokenAvailable={!!monestoToken}
      />

      <Switch>
        {/* Редирект с /company/dashboard на /company/dashboard/home */}
        <Redirect exact from={path} to={`${path}/home`} />

        {/* Профиль: /company/dashboard/crypto/profile */}
        <Route
          exact
          path={`${path}/crypto/profile`}
          render={(t) => <PagePersonalProfile userType={userType} {...t} />}
        />

        {/* Home: /company/dashboard/home */}
        <Route exact path={`${path}/home`}>
          <Home
            userType={userType}
            magmaToken={magmaToken}
            finariumToken={finariumToken}
            finariumUrl={finariumUrl}
            unifyToken={unifyToken}
            unifyUrl={unifyUrl}
            monestoToken={monestoToken}
            monestoUrl={monestoUrl}
            oauthSuccess={handleOauthSuccess}
          />
        </Route>

        {/* Finance: /company/dashboard/finance */}
        <PrivateRoute
          exact
          path={`${path}/finance`}
          hasAccess={!!magmaToken}
          redirectTo={`${path}/home`}
          render={(props) => <Magma userType={userType} magmaToken={magmaToken} magmaUrl={magmaUrl} {...props} />}
        />

        {/* Crypto: /company/dashboard/crypto */}
        <PrivateRoute
          exact
          path={`${path}/crypto`}
          hasAccess={!!finariumToken}
          redirectTo={`${path}/home`}
          render={(props) => (
            <Finarium userType={userType} finariumToken={finariumToken} finariumUrl={finariumUrl} {...props} />
          )}
        />

        {/* Investment: /company/dashboard/investment */}
        <PrivateRoute
          exact
          path={`${path}/investment`}
          hasAccess={!!unifyToken}
          redirectTo={`${path}/home`}
          render={(props) => <Unify userType={userType} unifyToken={unifyToken} unifyUrl={unifyUrl} {...props} />}
        />

        {/* Monesto: /company/dashboard/monesto */}
        <PrivateRoute
          exact
          path={`${path}/monesto`}
          hasAccess={!!monestoToken}
          redirectTo={`${path}/home`}
          render={(props) => (
            <Monesto userType={userType} monestoToken={monestoToken} monestoUrl={monestoUrl} {...props} />
          )}
        />

        {/* Fallback - если ни один маршрут не совпал */}
        <Route path='*'>
          <Redirect to={`${path}/home`} />
        </Route>
      </Switch>
    </div>
  );
};

export default Wrapper;

Wrapper.propTypes = {
  route: PropTypes.string.isRequired,
  userType: PropTypes.string.isRequired,
};
